export default "__VITE_ASSET__c240c7d4__"